import React, { useState } from "react";
import "./../../../../assets/css/Dashboard/ServicesKanban.scss";
import { Tag } from "primereact/tag";
import { getClassName } from "../../../../data/getColorType";
import {
  deletePatientTag,
  removePatientTags,
  setClinicalChecksPatientTags,
} from "../../../../dispatchers/clinicalChecksDispatchers";
import useTitanApp from "../../../../hooks/useTitanApp";
import { convertColor } from "../../../../utils/colorUtils";

export default function PatientTag({
  tag,
  index,
  patientId,
  showRemoveButton,
}) {
  const { clincicalChecksState, appState } = useTitanApp();
  const { currentPharmacyId } = appState || {};
  const { patientTag, clinicalChecksTags, clinicalChecksPharmacy } =
    clincicalChecksState || {};
  const { pharmacyID } = clinicalChecksPharmacy || {
    pharmacyID: "00000000-0000-0000-0000-000000000000",
  };
  const handleRemove = async (tag) => {
    const tagId = tag?.tagId;
    if (pharmacyID && patientId && tagId) {
      if (tag?.isWorkflow) {
        const filteredTags = clinicalChecksTags;
        setClinicalChecksPatientTags(filteredTags);
      }
      await deletePatientTag({
        currentPharmacyId: pharmacyID,
        patientId,
        tagId,
      });

      if (patientTag) {
        const updatedPatientTags = patientTag.filter((t) => t.tagId !== tagId);
        removePatientTags(updatedPatientTags);
      }
    }
  };

  return (
    <Tag
      key={index}
      severity="custom"
      style={{
        background: convertColor(tag?.tagColour || "salmon"),
      }}
      className="color-tag"
      value={
        tag ? (
          <>
            <span className={getClassName(tag?.tagColour)}>{tag?.tagName}</span>
            {showRemoveButton && (
              <button
                className="remove-tag-btn"
                onClick={() => handleRemove(tag)}
              >
                x
              </button>
            )}
          </>
        ) : (
          ""
        )
      }
    />
  );
}
